import { render, staticRenderFns } from "./HowToSearchMainCard.vue?vue&type=template&id=4971be7e&scoped=true&"
import script from "./HowToSearchMainCard.vue?vue&type=script&lang=js&"
export * from "./HowToSearchMainCard.vue?vue&type=script&lang=js&"
import style0 from "./HowToSearchMainCard.vue?vue&type=style&index=0&id=4971be7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4971be7e",
  null
  
)

export default component.exports